const useHeaderContent = () => {
  return {}
}

export default useHeaderContent
